module.exports = "https://assets.bwbx.io/s3/reg2/images/favicon-160x160-16c867e67ad0707e58d2.png";